<script>
import DrawerAside from "../../package/DrawerAside.vue";
import HeaderSection from "../../package/HeaderSection.vue";
import FooterSection from "../../package/footerSection.vue";
import EmailUsSectionLight from "../../contact/emailUsSectionLight.vue";
// import MobileAppDownload from "../../package/mobileAppDownload.vue";
import UConnectRegistrationSection4 from "./uConnectRegistrationSection4.vue";
import UConnectRegistrationSection3 from "./uConnectRegistrationSection3.vue";
import UConnectRegistrationSection2 from "./uConnectRegistrationSection2.vue";
import UConnectRegistrationSection1 from "./uConnectRegistrationSection1.vue";
import UConnectDirectRegistration from "./uConnectDirectRegistration.vue";
import UConnectSelectPlanDetailsStep from "./selectPackage/uConnectSelectPlanDetailsStep.vue";

export default {
  name: "uConnectRegistrationLayout",
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D",
    };
  },
  components: {
    UConnectDirectRegistration,
    UConnectSelectPlanDetailsStep,
    UConnectRegistrationSection1,
    UConnectRegistrationSection2,
    UConnectRegistrationSection3,
    UConnectRegistrationSection4,
    EmailUsSectionLight,
    FooterSection,
    HeaderSection,
    DrawerAside,
    // MobileAppDownload,
  },
  beforeUpdate() {
    document.title = "UNIFI Property: U-Connect";
  },
  created() {
    document.title = "UNIFI Property: U-Connect";
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    spread() {
      this.unfold = !this.unfold;
    },
    fold(unfold) {
      this.unfold = unfold;
    },
  }
}
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <!--      <breadcrumb-about-us />-->

        <u-connect-direct-registration/>
        <u-connect-select-plan-details-step/>

        <el-row>
          <el-col :span="24">
            <el-row class="step-row">
              <el-col :span="24" class="step-title"><span>Step 1</span></el-col>
              <el-col :span="24" class="step-desc"><span>Create account</span></el-col>
            </el-row>
            <el-row class="step-row">
              <el-col :span="24" class="step-title"><span>Step 2</span></el-col>
              <el-col :span="24" class="step-desc"><span>Explore off-the-plan property listings</span></el-col>
            </el-row>
            <el-row class="step-row">
              <el-col :span="24" class="step-title"><span>Step 3</span></el-col>
              <el-col :span="24" class="step-desc"><span>Submit your client referral to our Concierge Service</span></el-col>
            </el-row>
            <el-row class="step-row">
              <el-col :span="24" class="step-title"><span>Step 4</span></el-col>
              <el-col :span="24" class="step-desc"><span>Receive reward benefits upon successful sales</span></el-col>
            </el-row>
            <el-row class="step-row">
              <el-col :span="24" class="step-title"><span>Step 5</span></el-col>
              <el-col :span="24" class="step-desc"><span style="font-weight: bold">Repeat!</span></el-col>
            </el-row>
          </el-col>
        </el-row>
<!--        <uConnectRegistrationSection1 />-->
<!--        <uConnectRegistrationSection2 />-->
<!--        <uConnectRegistrationSection3 />-->
<!--        <uConnectRegistrationSection4 />-->
<!--        <email-us-section-light />-->
<!--        <mobile-app-download />-->
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
  </template>

<style scoped>
.mainWrapper {
  background-color: #ffffff;
  max-width: 1920px;
  margin: auto;
}

.step-row {
  font-size: 20px;
  letter-spacing: 2px;
  word-spacing: 2px;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}

.step-title {
  color: #003333;
  background-color: #cccccc;
  border-top: #003333 solid 1px;
  border-right: #003333 solid 1px;
  border-left: #003333 solid 1px;
  padding: 5px 0;
  width: 100%;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: center;
}

.step-desc {
  color: #ffffff;
  background-color: #003333;
  border-bottom: #003333 solid 1px;
  border-right: #003333 solid 1px;
  border-left: #003333 solid 1px;
  border-radius: 0 0 10px 10px;
  padding: 5px 0 10px 0;
  display: flex;
  justify-content: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/uConnectRegistrationLayout.vue